// frontend/src/components/shared/GuardedLink.tsx
//
// BUG-2026-0189 — a drop-in replacement for react-router's <Link> that routes
// its navigation through the shared unsaved-changes guard (useUnsavedGuard).
// When a test workflow page has registered a dirty guard, clicking a
// GuardedLink shows the Save & Leave / Discard & Leave / Cancel dialog instead
// of navigating away; everywhere else it behaves exactly like a normal Link
// (renders a real <a href> so middle-click / open-in-new-tab still work).

import type { CSSProperties, ReactNode } from 'react';
import { useGuardedNavigate } from '../../hooks/useUnsavedGuard';

interface GuardedLinkProps {
  to: string;
  children: ReactNode;
  style?: CSSProperties;
  className?: string;
  title?: string;
}

export const GuardedLink = ({ to, children, style, className, title }: GuardedLinkProps) => {
  const guardedNavigate = useGuardedNavigate();
  return (
    <a
      href={to}
      title={title}
      className={className}
      style={{ textDecoration: 'none', ...style }}
      onClick={(e) => {
        // Let modified clicks (new tab / new window) fall through to the browser.
        if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) {
          return;
        }
        e.preventDefault();
        guardedNavigate(to);
      }}
    >
      {children}
    </a>
  );
};
